import { Col, Form, Row } from "react-bootstrap";
import clsx from "clsx";
import React from "react";
import Button from "react-bootstrap/Button";

function ProfitAndLossSetting({ values, onChangeValues, onClickIntraDay, onClickReset }) {
  return (
    <Col sm={12} md={12} lg={6}>
      <div className="custom-table-statement-content my-3">
        <div className="custom-table-setoff-styled mb-3">
          <h3 className="py-3 px-3 text-bold-600 general-title">Settings</h3>
        </div>
        <Row className="pb-3">
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">No of Shares (x100)</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control
                  className="formControl"
                  type="number"
                  value={values?.no_of_shares}
                  onChange={(e) => {
                    onChangeValues("no_of_shares", e.target.value);
                  }}
                />
              </Form.Group>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">Buy Price</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control
                  className="formControl"
                  type="number"
                  value={values?.buy_price}
                  onChange={(e) => {
                    onChangeValues("buy_price", e.target.value);
                  }}
                />
              </Form.Group>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">Sell Price</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control
                  className="formControl"
                  type="number"
                  value={values?.sell_price}
                  onChange={(e) => {
                    onChangeValues("sell_price", e.target.value);
                  }}
                />
              </Form.Group>
            </div>
          </Col>

          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Brokerage < 100k (%)`}</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control
                  className="formControl"
                  type="number"
                  value={values?.brokerage_under_rate}
                  onChange={(e) => {
                    onChangeValues("brokerage_under_rate", e.target.value);
                  }}
                />
              </Form.Group>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Brokerage > 100k (%)`}</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control
                  className="formControl"
                  type="number"
                  value={values?.brokerage_over_rate}
                  onChange={(e) => {
                    onChangeValues("brokerage_over_rate", e.target.value);
                  }}
                />
              </Form.Group>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Min Brokerage`}</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Control
                  className="formControl"
                  type="number"
                  value={values?.min_brokerage}
                  onChange={(e) => {
                    onChangeValues("min_brokerage", e.target.value);
                  }}
                />
              </Form.Group>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">Is Warrant, Structure Warrant or ETF</h4>
            </div>
          </Col>

          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <Form.Group>
                <Form.Check // prettier-ignore
                  type="checkbox"
                  checked={values?.is_warrant}
                  onChange={(e,value) => {
                    onChangeValues("is_warrant", e.target.checked);
                  }}
                />
              </Form.Group>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <button
                className={clsx("btn custom-button-back")}
                style={{ backgroundColor: "#e2e3e5" }}
                onClick={onClickReset}
              >
                Reset
              </button>
              <button
                className={clsx("btn custom-button-primary ms-3")}
                style={{ backgroundColor: "#9D7905" }}
                onClick={onClickIntraDay}
              >
                IntraDay
              </button>
            </div>
          </Col>
        </Row>
      </div>
    </Col>
  );
}

export default ProfitAndLossSetting;
